export const DEFAULT_PAGE_SIZE_OPTIONS = [12, 24, 36];
export const DEFAULT_PAGE_SIZE = 12;

export interface PageableObject {
	pageNumber: number;
	pageSize: number;
	offset: number;
	paged: boolean;
	unpaged: boolean;
	sort: SortObject;
}

export interface Page<T> {
	content: T[];
	empty: boolean;
	first: boolean;
	last: boolean;
	number: number;
	numberOfElements: number;
	pageable: PageableObject;
	size: number;
	sort: SortObject;
	totalElements: number;
	totalPages: number;
}

export interface SortObject {
	unsorted: boolean;
	sorted: boolean;
	empty: boolean;
}

export interface PaginationParams<T> {
	page: number;
	size: number;
	sort?: SortDirection;
	sortBy?: T;
}

export interface OffsetPaginationParams {
	limit: number;
	offset: number;
}

export const getDefaultPaginationParms = <T>(): PaginationParams<T> => ({
	page: 0,
	size: DEFAULT_PAGE_SIZE,
});

export const toOffsetPaginationParams = (
	page: number,
	size: number = DEFAULT_PAGE_SIZE,
): OffsetPaginationParams => ({
	limit: size,
	offset: page * size,
});

export enum SortDirection {
	ASC = "ASC",
	DESC = "DESC",
}
